import {
  TableRow,
  TableCell,
  IconButton
} from "@mui/material";
import React, {useState} from "react";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { EditableInvoiceRow } from "./EditableInvoiceRow";
import CreateIcon from '@mui/icons-material/Create';


function InvoiceRow(props)
{
    const [showEditRow, setShowEditRow] = useState(false)
    return (
      <>
      {showEditRow ?
            <EditableInvoiceRow invoice = {props.invoice} handleEdit = {props.handleEdit} setEditInvoice = {setShowEditRow}/>
            :
            <TableRow>
                    <TableCell align = "center">
                      {`${props.invoice.first_name} ${props.invoice.last_name}`}
                    </TableCell >
                    <TableCell align = "center">{props.invoice.client}</TableCell>
                    <TableCell align = "center">
                      {moment
                        .utc(props.invoice.transaction_date)
                        .format("YYYY-MM-DD")
                        .toString()}
                    </TableCell>
                    <TableCell align = "center">
                      {props.invoice.due_date ? moment
                        .utc(props.invoice.due_date)
                        .format("YYYY-MM-DD")
                        .toString() : "N/A"}
                    </TableCell>
                    <TableCell align = "center">{props.invoice.hours}</TableCell>
                    {props.invoice.invoice_type.includes("Fixed") ? 
                    <TableCell align = "center">Fixed</TableCell>
                    :
                    <TableCell align = "center">{props.invoice.bill_rate}</TableCell>
                  }
                    
                    <TableCell align = "center">{props.invoice.amount}</TableCell>
                    <TableCell align = "center">{props.invoice.invoice_type}</TableCell>
                    <TableCell align = "center">{props.invoice.notes}</TableCell>
                    <TableCell align = "center">
                      <IconButton sx={{ marginLeft: 5 }} onClick={(e) => {e.preventDefault(); props.handleConfirm(props.invoice.id)}}>
                        <CheckIcon/>
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton sx={{ marginLeft: 5 }} onClick={(e) => {e.preventDefault(); props.handleReject(props.invoice.id)}}>
                        <ClearIcon/>
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton sx={{ marginLeft: 5 }} onClick={(e) => {e.preventDefault(); setShowEditRow(true);}}>
                        <CreateIcon/>
                      </IconButton>
                    </TableCell>
            </TableRow>
          }
      </>)
                      
}


export default InvoiceRow;
